import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Badge, ButtonSelect, Icon } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';

import './AdvancedFilters.css';

function AdvancedFilterButton({
  filters,
  showFilterBar,
  setShowFilterBar,
  showBadgeOnFilterButton,
  isButtonKindIcon,
}) {
  const {
    core: { isLoading },
    tabs: { tabData },
  } = useSelector((state) => state?.certifications?.details);
  const { messages } = useSelector((state) => state?.user);
  const intl = useIntl();

  const activeTabCount = tabData?.find((tab) => tab.isActive)?.count;

  const filterLabel =
    messages.CERTS_FILTER || localize(intl, getMessageKey('CERTS_FILTER'));
  const filterAppliedLabel =
    messages.CERTS_FILTER_APPLIED ||
    localize(intl, getMessageKey('CERTS_FILTER_APPLIED'));
  const ariaLabel = showBadgeOnFilterButton ? filterAppliedLabel : filterLabel;

  return (
    <div>
      <ButtonSelect
        ariaLabel={ariaLabel}
        label={
          messages.CERTS_FILTER || localize(intl, getMessageKey('CERTS_FILTER'))
        }
        kind={isButtonKindIcon ? 'rectangle' : 'icon'}
        className='CertsAdvancedFilterButton'
        onClick={() => {
          if (filters.length > 0) {
            setShowFilterBar((prev) => !prev);
          }
        }}
        isOpen={showFilterBar}
        size='medium'
        prefixIcon={
          <Icon kind='Filter' color='neutral-600' size='smallMedium' />
        }
        BadgeComp={
          showBadgeOnFilterButton ? (
            <Badge kind='dot' color='primary' size='small' />
          ) : null
        }
        isDisabled={filters.length === 0 || activeTabCount === 0 || isLoading}
      />
    </div>
  );
}

AdvancedFilterButton.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showFilterBar: PropTypes.bool.isRequired,
  setShowFilterBar: PropTypes.func.isRequired,
  showBadgeOnFilterButton: PropTypes.bool.isRequired,
  isButtonKindIcon: PropTypes.bool.isRequired,
};

export default AdvancedFilterButton;
